import { render } from "./DesignPage.vue?vue&type=template&id=fabb7458&scoped=true"
import script from "./DesignPage.vue?vue&type=script&lang=js"
export * from "./DesignPage.vue?vue&type=script&lang=js"

import "./DesignPage.vue?vue&type=style&index=0&id=fabb7458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabb7458"]])

export default __exports__